import { render, staticRenderFns } from "./NetpaUploader.vue?vue&type=template&id=2aeb45fc&"
import script from "./NetpaUploader.vue?vue&type=script&lang=js&"
export * from "./NetpaUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports